import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the training heart rate.
 **/
export const TextFieldTrainingHeartRate = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.trainingHR')}
        type="tel"
        name="trainingHeartRate"
        value={values.trainingHeartRate}
        error={touched.trainingHeartRate && Boolean(errors.trainingHeartRate)}
        helperText={touched.trainingHeartRate && errors.trainingHeartRate}
        onChange={handleChange}
    />
);

TextFieldTrainingHeartRate.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
